import React, { useEffect } from 'react';

const FontLoader = () => {
  useEffect(() => {
    // Load all fonts needed for the carousel generator
    const fonts = [
      // Modern Sans Serif - Verified Google Fonts
      'Poppins:400,500,600,700',
      'Inter:400,500,600,700',
      'Roboto:400,500,600,700',
      'Open+Sans:400,500,600,700',
      'Lato:400,700',
      'Montserrat:400,500,600,700',
      'Nunito+Sans:400,600,700',
      'Work+Sans:400,500,600,700',
      'Quicksand:400,500,600,700',
      'Source+Sans+Pro:400,600,700',
      'Raleway:400,500,600,700',
      'Ubuntu:400,500,700',
      'Mulish:400,500,600,700',
      'DM+Sans:400,500,700',
      'Rubik:400,500,600,700',
      'Karla:400,500,700',
      'Outfit:400,500,600,700',
      'Plus+Jakarta+Sans:400,500,600,700',
      'Manrope:300,400,700,800',
      'Lexend:400,500,600,700',
      'Public+Sans:400,500,600,700',
      'Barlow:400,500,600,700',
      
      // New modern sans-serif fonts - Verified Google Fonts
      'Sora:400,500,600,700',
      'Space+Grotesk:400,500,600,700',
      'Archivo:400,500,600,700',
      'Urbanist:400,500,600,700',
      'Jost:400,500,600,700',
      'Figtree:400,500,600,700',
      'Epilogue:400,500,600,700',
      'Kumbh+Sans:400,500,600,700',
      'Instrument+Sans:400,500,600,700',
      'Noto+Sans:400,500,600,700',
      'Heebo:400,500,600,700',
      
      // Serif fonts - Verified Google Fonts
      'Playfair+Display:400,500,600,700',
      'Merriweather:400,700',
      'Lora:400,500,600,700',
      'Fraunces:400,500,600,700',
      'Libre+Baskerville:400,700',
      'Source+Serif+Pro:400,600,700',
      'Crimson+Pro:400,500,600,700',
      'Cormorant+Garamond:400,500,600,700',
      'Newsreader:400,500,600,700',
      'EB+Garamond:400,500,600,700',
      'Spectral:400,500,600,700',
      'Bitter:400,500,600,700',
      'Arvo:400,700',
      
      // Display/Headline fonts - Verified Google Fonts
      'Dancing+Script:400,500,600,700',
      'Bebas+Neue:400',
      'Abril+Fatface:400',
      'Oswald:400,500,600,700',
      'Pacifico:400',
      'Righteous:400',
      'Permanent+Marker:400',
      'Caveat:400,500,600,700',
      'Comfortaa:400,500,600,700',
      'Lobster:400',
      'Anton:400',
      'Teko:400,500,600,700',
      'Staatliches:400',
      
      // Monospace fonts - Verified Google Fonts
      'Roboto+Mono:400,500,600,700',
      'Source+Code+Pro:400,500,600,700',
      'JetBrains+Mono:400,500,600,700',
      'Space+Mono:400,700',
      'Fira+Mono:400,500,700',
      'IBM+Plex+Mono:400,500,600,700',
      'Inconsolata:400,500,600,700',
      'Courier+Prime:400,700',
      'DM+Mono:400,500'
    ];
    
    // Create a single link element with all fonts
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `https://fonts.googleapis.com/css2?${fonts.map(font => `family=${font}`).join('&')}&display=swap`;
    document.head.appendChild(link);
    
    return () => {
      // Clean up
      document.head.removeChild(link);
    };
  }, []);

  return null;
};

export default FontLoader; 